import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { gpedPedidosPaginacionFilterParams } from "../interfaces/gpedPedidosPaginacionFilterParams";
import { computed, Ref, watch, onMounted, onUnmounted } from "vue";
import { ListPedidosAction } from "../actions";
import socketPedido from "@/modules/pedidos/services/socketPedido.service";
// 👈 Importamos WebSocket

export function usePedidosList(params: Ref<gpedPedidosPaginacionFilterParams>) {
  const queryClient = useQueryClient();

  // Query principal HTTP
  const query = useQuery({
    queryKey: ["gpedListPedidos", params],
    queryFn: () => ListPedidosAction(params.value),
    staleTime: 60 * 1000,
  });

  // Datos derivados
  const pedidos = computed(() => query.data.value?.data?.data?.pedidos || []);
  const total = computed(() => query.data.value?.data?.data?.total || 0);
  const totalPages = computed(
    () => query.data.value?.data?.data?.totalPages || 0
  );
  const currentPage = computed(() => query.data.value?.data?.data?.page || 1);

  // Prefetch en cambios de filtros
  watch(
    params,
    (newParams) => {
      queryClient.prefetchQuery({
        queryKey: ["gpedListPedidos", newParams],
        queryFn: () => ListPedidosAction(newParams),
      });
    },
    { deep: true }
  );

  const invalidatePedidos = () => {
    void queryClient.invalidateQueries({ queryKey: ["gpedListPedidos"] });
  };

  // ⬇️⬇️ — INTEGRACIÓN WEBSOCKET REAL — ⬇️⬇️
  onMounted(() => {
    socketPedido.on("listaActualizada", invalidatePedidos);
    socketPedido.on("nuevoPedido", invalidatePedidos);
    socketPedido.on("pedidoActualizado", invalidatePedidos);
    socketPedido.on("pedidoEliminado", invalidatePedidos);
  });

  onUnmounted(() => {
    socketPedido.off("listaActualizada", invalidatePedidos);
    socketPedido.off("nuevoPedido", invalidatePedidos);
    socketPedido.off("pedidoActualizado", invalidatePedidos);
    socketPedido.off("pedidoEliminado", invalidatePedidos);
  });

  return {
    ...query,
    pedidos,
    total,
    totalPages,
    currentPage,
  };
}
